/**
 * Glossary.js
 *
 * Interactions for the glossary of terms template
 */
(function boot($) {
  var app = {};

  // Initialize
  app.init = function () {
    this.menu();
  };

  // Menu
  app.menu = function () {
    // Capture main nav menu
    var $glossaryMenu = $(".glossary__menu");
    if (!$glossaryMenu.length) return;

    // Capture main nav menu
    $glossaryMenu.on("click", "a", function (e) {
      $(".glossary__letter-container").hide().fadeIn(350);
    });
  };

  // Boot
  app.init();
})(window.jQuery);
